import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _278ea860 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _14abc094 = () => interopDefault(import('..\\pages\\bidopening-site\\index.vue' /* webpackChunkName: "pages/bidopening-site/index" */))
const _809ea194 = () => interopDefault(import('..\\pages\\cfgyl\\index.vue' /* webpackChunkName: "pages/cfgyl/index" */))
const _7889bb9c = () => interopDefault(import('..\\pages\\companyList\\index.vue' /* webpackChunkName: "pages/companyList/index" */))
const _6af7612d = () => interopDefault(import('..\\pages\\contact\\index.vue' /* webpackChunkName: "pages/contact/index" */))
const _89a3d942 = () => interopDefault(import('..\\pages\\download\\index.vue' /* webpackChunkName: "pages/download/index" */))
const _3d7a669a = () => interopDefault(import('..\\pages\\industryTrends\\index.vue' /* webpackChunkName: "pages/industryTrends/index" */))
const _71dd9c4e = () => interopDefault(import('..\\pages\\platHelpList\\index.vue' /* webpackChunkName: "pages/platHelpList/index" */))
const _24911799 = () => interopDefault(import('..\\pages\\policiesList\\index.vue' /* webpackChunkName: "pages/policiesList/index" */))
const _5feb7941 = () => interopDefault(import('..\\pages\\question\\index.vue' /* webpackChunkName: "pages/question/index" */))
const _43254338 = () => interopDefault(import('..\\pages\\register\\index.vue' /* webpackChunkName: "pages/register/index" */))
const _595225c0 = () => interopDefault(import('..\\pages\\site\\index.vue' /* webpackChunkName: "pages/site/index" */))
const _4248c3ae = () => interopDefault(import('..\\pages\\trade\\index.vue' /* webpackChunkName: "pages/trade/index" */))
const _4bfc33a1 = () => interopDefault(import('..\\pages\\companyList\\detail.vue' /* webpackChunkName: "pages/companyList/detail" */))
const _9a93794e = () => interopDefault(import('..\\pages\\components\\web-auto.vue' /* webpackChunkName: "pages/components/web-auto" */))
const _139bff0a = () => interopDefault(import('..\\pages\\components\\web-detail.vue' /* webpackChunkName: "pages/components/web-detail" */))
const _a5abf270 = () => interopDefault(import('..\\pages\\components\\web-list.vue' /* webpackChunkName: "pages/components/web-list" */))
const _418fbaba = () => interopDefault(import('..\\pages\\components\\web-single-page.vue' /* webpackChunkName: "pages/components/web-single-page" */))
const _412c4d80 = () => interopDefault(import('..\\pages\\industryTrends\\detail.vue' /* webpackChunkName: "pages/industryTrends/detail" */))
const _bc451b68 = () => interopDefault(import('..\\pages\\pcas\\loading.vue' /* webpackChunkName: "pages/pcas/loading" */))
const _05e4eb1a = () => interopDefault(import('..\\pages\\policiesList\\detail.vue' /* webpackChunkName: "pages/policiesList/detail" */))
const _d62992ec = () => interopDefault(import('..\\pages\\trade\\detail.vue' /* webpackChunkName: "pages/trade/detail" */))
const _205926bc = () => interopDefault(import('..\\pages\\trade\\index copy.vue' /* webpackChunkName: "pages/trade/index copy" */))
const _e4bf2992 = () => interopDefault(import('..\\pages\\register\\components\\btn-yzm.vue' /* webpackChunkName: "pages/register/components/btn-yzm" */))
const _4de49bb6 = () => interopDefault(import('..\\pages\\register\\components\\captcha.vue' /* webpackChunkName: "pages/register/components/captcha" */))
const _964ac4b6 = () => interopDefault(import('..\\pages\\register\\components\\input-yzm.vue' /* webpackChunkName: "pages/register/components/input-yzm" */))
const _2933ad94 = () => interopDefault(import('..\\pages\\register\\components\\tos.vue' /* webpackChunkName: "pages/register/components/tos" */))
const _e65ac670 = () => interopDefault(import('..\\pages\\trade\\components\\link-paper.vue' /* webpackChunkName: "pages/trade/components/link-paper" */))
const _42df335c = () => interopDefault(import('..\\pages\\trade\\components\\my-pagination.vue' /* webpackChunkName: "pages/trade/components/my-pagination" */))
const _34d504a7 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _19c02144 = () => interopDefault(import('..\\pages\\index\\components\\cjwt-dialog.vue' /* webpackChunkName: "pages/index/components/cjwt-dialog" */))
const _f7db8a96 = () => interopDefault(import('..\\pages\\index\\components\\right-bar.vue' /* webpackChunkName: "pages/index/components/right-bar" */))
const _5594112b = () => interopDefault(import('..\\pages\\index\\components\\search-bar.vue' /* webpackChunkName: "pages/index/components/search-bar" */))
const _841e6f90 = () => interopDefault(import('..\\pages\\index\\sections\\ad.vue' /* webpackChunkName: "pages/index/sections/ad" */))
const _8d106f7e = () => interopDefault(import('..\\pages\\index\\sections\\banner.vue' /* webpackChunkName: "pages/index/sections/banner" */))
const _f610fbac = () => interopDefault(import('..\\pages\\index\\sections\\index-link.vue' /* webpackChunkName: "pages/index/sections/index-link" */))
const _9817cffa = () => interopDefault(import('..\\pages\\index\\sections\\info.vue' /* webpackChunkName: "pages/index/sections/info" */))
const _0706b8b0 = () => interopDefault(import('..\\pages\\index\\sections\\news.vue' /* webpackChunkName: "pages/index/sections/news" */))
const _d0d15ece = () => interopDefault(import('..\\pages\\index\\sections\\quick-access.vue' /* webpackChunkName: "pages/index/sections/quick-access" */))
const _9eb37c42 = () => interopDefault(import('..\\pages\\index\\sections\\trade.vue' /* webpackChunkName: "pages/index/sections/trade" */))
const _017a8a4a = () => interopDefault(import('..\\pages\\index\\sections\\week-order.vue' /* webpackChunkName: "pages/index/sections/week-order" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _278ea860,
    alias: "/about/index.html",
    name: "about"
  }, {
    path: "/bidopening-site",
    component: _14abc094,
    alias: "/bidopening-site/index.html",
    name: "bidopening-site"
  }, {
    path: "/cfgyl",
    component: _809ea194,
    alias: "/cfgyl/index.html",
    name: "cfgyl"
  }, {
    path: "/companyList",
    component: _7889bb9c,
    alias: "/companyList/index.html",
    name: "companyList"
  }, {
    path: "/contact",
    component: _6af7612d,
    alias: "/contact/index.html",
    name: "contact"
  }, {
    path: "/download",
    component: _89a3d942,
    alias: "/download/index.html",
    name: "download"
  }, {
    path: "/industryTrends",
    component: _3d7a669a,
    alias: "/industryTrends/index.html",
    name: "industryTrends"
  }, {
    path: "/platHelpList",
    component: _71dd9c4e,
    alias: "/platHelpList/index.html",
    name: "platHelpList"
  }, {
    path: "/policiesList",
    component: _24911799,
    alias: "/policiesList/index.html",
    name: "policiesList"
  }, {
    path: "/question",
    component: _5feb7941,
    alias: "/question/index.html",
    name: "question"
  }, {
    path: "/register",
    component: _43254338,
    alias: "/register/index.html",
    name: "register"
  }, {
    path: "/site",
    component: _595225c0,
    alias: "/site/index.html",
    name: "site"
  }, {
    path: "/trade",
    component: _4248c3ae,
    alias: "/trade/index.html",
    name: "trade"
  }, {
    path: "/companyList/detail",
    component: _4bfc33a1,
    alias: "/companyList/detail/index.html",
    name: "companyList-detail"
  }, {
    path: "/components/web-auto",
    component: _9a93794e,
    alias: "/components/web-auto/index.html",
    name: "components-web-auto"
  }, {
    path: "/components/web-detail",
    component: _139bff0a,
    alias: "/components/web-detail/index.html",
    name: "components-web-detail"
  }, {
    path: "/components/web-list",
    component: _a5abf270,
    alias: "/components/web-list/index.html",
    name: "components-web-list"
  }, {
    path: "/components/web-single-page",
    component: _418fbaba,
    alias: "/components/web-single-page/index.html",
    name: "components-web-single-page"
  }, {
    path: "/industryTrends/detail",
    component: _412c4d80,
    alias: "/industryTrends/detail/index.html",
    name: "industryTrends-detail"
  }, {
    path: "/pcas/loading",
    component: _bc451b68,
    alias: "/pcas/loading/index.html",
    name: "pcas-loading"
  }, {
    path: "/policiesList/detail",
    component: _05e4eb1a,
    alias: "/policiesList/detail/index.html",
    name: "policiesList-detail"
  }, {
    path: "/trade/detail",
    component: _d62992ec,
    alias: "/trade/detail/index.html",
    name: "trade-detail"
  }, {
    path: "/trade/index%20copy",
    component: _205926bc,
    alias: "/trade/index%20copy/index.html",
    name: "trade-index copy"
  }, {
    path: "/register/components/btn-yzm",
    component: _e4bf2992,
    alias: "/register/components/btn-yzm/index.html",
    name: "register-components-btn-yzm"
  }, {
    path: "/register/components/captcha",
    component: _4de49bb6,
    alias: "/register/components/captcha/index.html",
    name: "register-components-captcha"
  }, {
    path: "/register/components/input-yzm",
    component: _964ac4b6,
    alias: "/register/components/input-yzm/index.html",
    name: "register-components-input-yzm"
  }, {
    path: "/register/components/tos",
    component: _2933ad94,
    alias: "/register/components/tos/index.html",
    name: "register-components-tos"
  }, {
    path: "/trade/components/link-paper",
    component: _e65ac670,
    alias: "/trade/components/link-paper/index.html",
    name: "trade-components-link-paper"
  }, {
    path: "/trade/components/my-pagination",
    component: _42df335c,
    alias: "/trade/components/my-pagination/index.html",
    name: "trade-components-my-pagination"
  }, {
    path: "/",
    component: _34d504a7,
    alias: "/index.html",
    name: "index",
    children: [{
      path: "components/cjwt-dialog",
      component: _19c02144,
      name: "index-components-cjwt-dialog"
    }, {
      path: "components/right-bar",
      component: _f7db8a96,
      name: "index-components-right-bar"
    }, {
      path: "components/search-bar",
      component: _5594112b,
      name: "index-components-search-bar"
    }, {
      path: "sections/ad",
      component: _841e6f90,
      name: "index-sections-ad"
    }, {
      path: "sections/banner",
      component: _8d106f7e,
      name: "index-sections-banner"
    }, {
      path: "sections/index-link",
      component: _f610fbac,
      name: "index-sections-index-link"
    }, {
      path: "sections/info",
      component: _9817cffa,
      name: "index-sections-info"
    }, {
      path: "sections/news",
      component: _0706b8b0,
      name: "index-sections-news"
    }, {
      path: "sections/quick-access",
      component: _d0d15ece,
      name: "index-sections-quick-access"
    }, {
      path: "sections/trade",
      component: _9eb37c42,
      name: "index-sections-trade"
    }, {
      path: "sections/week-order",
      component: _017a8a4a,
      name: "index-sections-week-order"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
